function readUserAgent(ua) {
  if (typeof ua === 'string') {
    return ua
  }
  if (typeof navigator === 'undefined') {
    return ''
  }
  return navigator.userAgent || ''
}

function parseHarmonyOSVersion(ua) {
  const match = ua.match(/HarmonyOS(?:\s+Next)?[/\s_-]+(\d+)/i)
  if (!match) {
    return null
  }
  const version = Number(match[1])
  return Number.isFinite(version) ? version : null
}

/** HarmonyOS 5+ / NEXT 才能安装鸿蒙应用；HarmonyOS 4 及以下仍走安卓应用市场 */
export function isHarmonyOSNext(ua) {
  const value = readUserAgent(ua)
  if (!value) {
    return false
  }

  if (/OpenHarmony/i.test(value) || /ArkWeb/i.test(value)) {
    return true
  }

  const version = parseHarmonyOSVersion(value)
  return version !== null && version >= 5
}

export function isHuaweiAndroid(ua) {
  const value = readUserAgent(ua)
  if (!value || isHarmonyOSNext(value)) {
    return false
  }

  if (/harmonyos/i.test(value)) {
    return true
  }

  return /huawei/i.test(value)
}

export function detectMobilePlatform(ua) {
  const value = readUserAgent(ua)
  if (!value) {
    return null
  }

  if (/iphone|ipad|ipod/i.test(value)) {
    return 'ios'
  }

  if (isHarmonyOSNext(value)) {
    return 'harmonyos'
  }

  if (isHuaweiAndroid(value)) {
    return 'huawei-android'
  }

  if (/android/i.test(value)) {
    return 'android'
  }

  return null
}
